<span *ngIf="tag">
  {{ tag.name }}
  <button (click)="remove.emit(tag)">
    <app-icon src="assets/images/cross-remove.svg"></app-icon>
  </button>
</span>
